export class SampleTransaction {
  paymentAdviceCurrency?: string;
  paymentAdviceAmount: number;
  paymentAdviceNumber?: string;
  awbNumber?: string;
  airportCode?: string;
  operationMode?: string;
  isSSERequired: string;
  source: string;
  signatureRequirement?: string;
  customerID?: string;
  customerName?: string;
  accountNumber?: number;
  signatureRequired?: string;
  transactionId?: string;

  constructor(
    paymentAdviceCurrency: string,
    paymentAdviceAmount: number,
    paymentAdviceNumber: string,
    awbNumber: string,
    airportCode: string,
    operationMode: string,
    isSSERequired: string,
    source: string,
    signatureRequirement?: string,
    customerID?: string,
    customerName?: string,
    accountNumber?: number,
    signatureRequired?: string,
    transactionId?: string
  ) {
    this.paymentAdviceCurrency = paymentAdviceCurrency;
    this.paymentAdviceAmount = paymentAdviceAmount;
    this.paymentAdviceNumber = paymentAdviceNumber;
    this.awbNumber = awbNumber;
    this.airportCode = airportCode;
    this.operationMode = operationMode;
    this.isSSERequired = isSSERequired;
    this.source = source;
    this.signatureRequirement = signatureRequirement;
    this.customerID = customerID;
    this.customerName = customerName;
    this.accountNumber = accountNumber;
    this.signatureRequired = signatureRequired;
    this.transactionId = transactionId;
  }
}
